import { render, staticRenderFns } from "./ChatPreview.vue?vue&type=template&id=2b74f8c3&scoped=true"
import script from "./ChatPreview.vue?vue&type=script&lang=js"
export * from "./ChatPreview.vue?vue&type=script&lang=js"
import style0 from "./ChatPreview.vue?vue&type=style&index=0&id=2b74f8c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b74f8c3",
  null
  
)

export default component.exports